{
  "fieldia": "0.13",
  "id": "appointment-booking",
  "title": "Book an appointment",
  "description": "Pick a service and a time that suits you. We confirm by email straight away.",
  "data": {
    "kind": "responses"
  },
  "maxWidth": "medium",
  "look": {
    "theme": "apple"
  },
  "fields": {
    "service": {
      "type": "selection",
      "label": "Service",
      "required": true,
      "options": [
        {
          "value": "consultation",
          "label": "First consultation, 30 min",
          "caption": "Getting to know you and what you need",
          "icon": "user"
        },
        {
          "value": "follow_up",
          "label": "Follow-up, 20 min",
          "caption": "For patients seen in the last three months",
          "icon": "history"
        },
        {
          "value": "review",
          "label": "Full review, 60 min",
          "caption": "Tests, and a full plan to follow",
          "icon": "list"
        }
      ]
    },
    "when": {
      "type": "datetime",
      "label": "Day and time",
      "required": true,
      "min": "today"
    },
    "visit": {
      "type": "selection",
      "label": "Where",
      "required": true,
      "options": [
        {
          "value": "in_person",
          "label": "In person",
          "caption": "At the clinic",
          "icon": "building"
        },
        {
          "value": "video",
          "label": "Video call",
          "caption": "The link comes by email an hour before",
          "icon": "chat"
        }
      ],
      "default": "in_person"
    },
    "name": {
      "type": "char",
      "label": "Your name",
      "required": true
    },
    "phone": {
      "type": "char",
      "label": "Phone",
      "required": true
    },
    "email": {
      "type": "char",
      "label": "Email",
      "required": true,
      "pattern": "^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$"
    },
    "first_visit": {
      "type": "boolean",
      "label": "This is my first visit",
      "default": true
    },
    "notes": {
      "type": "text",
      "label": "Anything we should know?",
      "size": 1000
    },
    "reminder": {
      "type": "boolean",
      "label": "Text me a reminder the day before",
      "default": true
    }
  },
  "layout": {
    "type": "sections",
    "id": "booking",
    "children": [
      {
        "type": "section",
        "id": "when",
        "title": "When",
        "columns": 2,
        "children": [
          {
            "type": "field",
            "id": "f-service",
            "field": "service",
            "widget": "radio",
            "colspan": 2
          },
          {
            "type": "field",
            "id": "f-when",
            "field": "when",
            "widget": "slots",
            "colspan": 2,
            "options": {
              "schedule": "appointments",
              "dependsOn": [
                "service"
              ]
            }
          },
          {
            "type": "field",
            "id": "f-visit",
            "field": "visit",
            "widget": "radio",
            "colspan": 2
          }
        ]
      },
      {
        "type": "section",
        "id": "who",
        "title": "Who is coming",
        "columns": 2,
        "children": [
          {
            "type": "field",
            "id": "f-name",
            "field": "name"
          },
          {
            "type": "field",
            "id": "f-phone",
            "field": "phone",
            "widget": "phone"
          },
          {
            "type": "field",
            "id": "f-email",
            "field": "email",
            "widget": "email"
          },
          {
            "type": "field",
            "id": "f-first",
            "field": "first_visit"
          },
          {
            "type": "field",
            "id": "f-notes",
            "field": "notes",
            "colspan": 2
          },
          {
            "type": "field",
            "id": "f-reminder",
            "field": "reminder",
            "widget": "toggle",
            "colspan": 2
          }
        ]
      }
    ]
  },
  "endings": [
    {
      "when": "visit == 'video'",
      "title": "You are booked, {name}",
      "text": "Your booking is {id}: {service}, by video call.\nWe call you on {when}: the link to join comes to {email} an hour before.",
      "again": "Book another"
    },
    {
      "title": "You are booked, {name}",
      "text": "Your booking is {id}: {service}.\nSee you on {when}. We have sent the details to {email}.",
      "again": "Book another"
    }
  ]
}
